import { Nullable, ServiceQuery } from 'chaika-frontend-types/frontend-cms';

import { AsyncSelect, AsyncSelectProps } from '@components/Select';
import { useServiceOptions } from './hooks/useServiceOptions';

interface Props extends Omit<AsyncSelectProps, 'loadOptions' | 'selectedValue'> {
    serviceId?: Nullable<string>;
    serviceQuery?: ServiceQuery;
    onlySelectedOption?: boolean;
}

export function ServiceSelect({ serviceId, serviceQuery, onlySelectedOption, defaultOptions, ...props }: Props) {
    const { defaultOptions: serviceOptions, loadOptions } = useServiceOptions({
        serviceQuery,
        onlySelectedOption,
        selectedIds: serviceId ? [serviceId] : [],
    });

    return (
        <AsyncSelect
            selectedValue={serviceId}
            defaultOptions={defaultOptions ?? serviceOptions}
            loadOptions={loadOptions}
            {...props}
        />
    );
}
